<div class="common-modal">
  <div class="modal-header">
    <div class="header-container">

      <div class="title-wrapper">
        <div class="top">
          <i class="icon ic-refresh-20"></i>
          <h2 class="title" [title]="header">{{ header }}</h2>
        </div>
      </div>

      <app-ag-action-icon-button
        iconClass="ic-close-16"
        (action)="close()"
      />
    </div>
  </div>

  <form class="modal-body" (ngSubmit)="$event.preventDefault();submit()">
    <div>
      <div class="update-message mb-3">{{ updatePropMessage }}</div>

      <div class="d-flex justify-content-center align-items-center flex-shrink-1">
        <div class="comparison">
          <div class="m-auto">
            <div class="before" [innerHtml]="valueBefore"></div>
          </div>

          <i class="icon ic-arrow-right-20"></i>

          <div class="m-auto">
            <div class="after" [innerHtml]="valueAfter"></div>
          </div>
        </div>
      </div>
    </div>

    <button type="submit" hidden></button>
  </form>

  <div class="modal-footer">
    <div class="left">
      <app-button
        text="Update"
        [isDisabled]="isLoading()"
        (clickBtn)="submit()"
      />
      <app-button
        text="Ignore"
        btnColor="white"
        [isDisabled]="isLoading()"
        (clickBtn)="close()"
      />
    </div>

    <div class="right">
      <app-button
        text="Close"
        btnColor="white"
        [isDisabled]="isLoading()"
        (clickBtn)="close()"/>
    </div>
  </div>
</div>
